"use strict";
import { MouseoverTooltip, TooltipSize } from "components/Tooltip";
import { Flex } from "ui/src";
import { BlueVerified } from "ui/src/components/icons/BlueVerified";
import { GoldenVerified } from "ui/src/components/icons/GoldenVerified";
import { GreenVerified } from "ui/src/components/icons/GreenVerified";
export default function BadgeProvider({ text, children }) {
  return <Flex cursor="pointer">
      <MouseoverTooltip text={text} size={TooltipSize.Max} placement="top">
        {children}
      </MouseoverTooltip>
    </Flex>;
}
export function GoldenBadgeVerified({ size = 18 }) {
  return <BadgeProvider text="Verified gauge">
      <GoldenVerified size={size} />
    </BadgeProvider>;
}
export function BlueBadgeVerified({ size = 18 }) {
  return <BadgeProvider text="Verified token">
      <BlueVerified size={size} />
    </BadgeProvider>;
}
export function GreenBadgeVerified({ size = 18 }) {
  return <BadgeProvider text="Dynamic gauge">
      <GreenVerified size={size} />
    </BadgeProvider>;
}
